import "./FsnbPartNorm.css";

import { useEffect, useRef, useState } from "react";
import Draggable from "react-draggable";

import apiFsnb from "api/fsnb";
import AlertLoading from "components/AlertLoading";
import Table from "components/Table/Table";
import KsprButton from "components/UI/buttons/KsprButton";
import { arrProxy } from "core/iterable_utils";

import PartNormColumns from "../TableSetting/PartNormColumns.js";

export default function FsnbPartNorm(props) {
	const [data, setData] = useState([]);
	const [allCount, setAllCount] = useState(0);
	const scrollBlock = useRef(null);
	const [fetchStatus, setFetchStatus] = useState(null);
	const [fetchStatusText, setFetchStatusText] = useState("");

	const columnsData = PartNormColumns();

	useEffect(() => {
		setFetchStatus("loading");
		const prom = apiFsnb.getPartNorm(props.vers.id, props.row.code, 0);
		prom.then((responce) => {
			setData(responce.data.data);
			setAllCount(responce.data.meta.data_len);
			setFetchStatus("success");
		}).catch((error) => {
			console.error(error);
			setFetchStatus("failed");
			setFetchStatusText(error);
		});
	}, [props.vers, props.row.code]); // eslint-disable-line react-hooks/exhaustive-deps

	let boxWidth = "90%";
	if (props.width != null) boxWidth = props.width;

	const changeNormContentVisible = (clickedRow, contentType) => {
		setData((prev) => [
			...prev.map((row) => {
				if (row.id === clickedRow.id) {
					if (contentType === "content") {
						row.contentVisibility = !row.contentVisibility;
					} else if (contentType === "resources") {
						row.resourcesVisibility = !row.resourcesVisibility;
					}

					if (row.contentVisibility && row.resourcesVisibility) {
						row._children = [...arrProxy(row.norm_content), ...arrProxy(row.norm_resource)];
					} else if (row.contentVisibility && !row.resourcesVisibility) {
						row._children = [...arrProxy(row.norm_content)];
					} else if (!row.contentVisibility && row.resourcesVisibility) {
						row._children = [...arrProxy(row.norm_resource)];
					} else if (!row.contentVisibility && !row.resourcesVisibility) {
						row._children = [];
					}
				}
				return row;
			}),
		]);
	};

	return (
		<Draggable handle=".FsnbPartNormBoxHeaderLabel">
			<div className="FsnbPartNormBox" style={{ width: boxWidth }}>
				<div className="FsnbPartNormBoxHeader">
					<div className="FsnbPartNormBoxHeaderLabel">
						<div> {props.name}</div>
						<div> Количество: {allCount}</div>
					</div>
				</div>
				<div className="FsnbCoefBoxBody">
					<div className="FsnbBodyRight" table_type="norm" ref={scrollBlock}>
						<Table
							rowData={data}
							columnsData={columnsData}
							scrollBlock={scrollBlock}
							options={{
								selectOptions: {
									controlled: true,
								},
								displayOptions: {
									displayScrollDelay: 20,
								},
							}}
							funcs={{
								setTableData: ({ newTableData }) => setData(newTableData),
								customFuncs: { changeNormContentVisible },
							}}
						></Table>
					</div>
				</div>
				<div className="FsnbPartNormBoxFooter">
					<KsprButton variant="text" label="Закрыть" onClick={props.f_closeCoefBox} />
				</div>
				<AlertLoading fetchStatus={fetchStatus} fetchStatusText={fetchStatusText} func={setFetchStatus} />
			</div>
		</Draggable>
	);
}
